export default __webpack_public_path__ + "static/media/cta-record.022e4e22.svg";